import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';

import { RecargaCredito } from './recargaCredito';

import myGlobals = require('../config');

@Injectable()
export class RecargaCreditoService {

    private recargaCreditoUrl = myGlobals.default.BASE_URL + '/recargaCredito/';  // URL to web api

    constructor(private http: Http) { }

    //Obtener recargas para una empresa
    getRecargasCreditoByEmpresa(_id: string): Observable<RecargaCredito> {
        return this.http.get(this.recargaCreditoUrl + _id)
            .map((response) => response.json());
    }

    save(recargaCredito: RecargaCredito): Observable<RecargaCredito> {
        //Seteo estado activo
        recargaCredito.estado = true;
        return this.post(recargaCredito);
    }

    //Desactivar recarga
    delete(idRecargaCredito: string) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        let url = `${this.recargaCreditoUrl}/${idRecargaCredito}`;

        return this.http
            .delete(url, { headers: headers })
            .map((response) => response.json());
    }

    // Agregar nueva recarga
    private post(recargaCredito: RecargaCredito): Observable<RecargaCredito> {
        let headers = new Headers({
            'Content-Type': 'application/json;charset=UTF-8'
        });
        headers.append('dataType', 'json');
        var recargaCreditoStr = JSON.stringify(recargaCredito);
        return this.http
            .post(this.recargaCreditoUrl, recargaCreditoStr, { headers: headers })
            .map((response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/recargaCredito/recargaCredito.service.ts